// extracted by mini-css-extract-plugin
export default {"loading_wrap":"Loading_loading_wrap__Ou1F5","load":"Loading_load__miC9D","loading_box":"Loading_loading_box__WqnWZ","loading_img":"Loading_loading_img__9+Xmc"};